import { useState } from "react";

const useSound = (url: string) => {
  const sound = new Audio(url);

  const [audio, setAudio] = useState(sound);

  const playSound = () => {
    audio.play();
  };

  return {
    playSound,
  };
};

export default useSound;